import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "ffe1610c-b07c-46eb-9a61-eb4323747877",
    content: "Ld (1m) = 105.0 dB<br>Ld (4m) = 94.9 dB<br>Ld (16m) = 82.9 dB",
    options: {},
  },
  {
    id: "654e8e59-db05-45e4-a0ec-d56e528b27cb",
    content: "Ld (1m) = 106.0 dB<br>Ld (4m) = 93.9 dB<br>Ld (16m) = 81.9 dB",
    options: {},
  },
  {
    id: "257b2666-3bea-4195-8026-f2d6d02ed322",
    content: "Ld (1m) = 106.9 dB<br>Ld (4m) = 99.9 dB<br>Ld (16m) = 89.0 dB",
    options: {},
  },
  {
    id: "7b98eea0-b330-4165-abec-a936fbce0653",
    content: "Ld (1m) = 105.9 dB<br>Ld (4m) = 93.0 dB<br>Ld (16m) = 81.0 dB",
    options: {},
  },
];

export const task: Task = {
  id: "bd5a67ea-1aa6-4199-98f2-9f60ef4b08f8",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["654e8e59-db05-45e4-a0ec-d56e528b27cb"],
};
